import { useAppSelector } from "../store/store";
import { ITimezone } from "../store/reducers/userReducer/userReducerTypes";

/**
 * Хук для получения таймзоны пользователя из store
 * @returns объект ITimezone или undefined, если таймзона не установлена
 */
export const useUserTimezone = (): ITimezone | undefined => {
  return useAppSelector(state => state.user.oneItemObject.item.timezone);
};

/**
 * Хук для получения offset таймзоны пользователя в минутах
 * @returns offset в минутах (по умолчанию 0, если таймзона не установлена)
 */
export const useUserTimezoneOffset = (): number => {
  const timezone = useUserTimezone();
  return timezone?.offset ?? 0;
};

